/* eslint-disable no-cond-assign */
import React from 'react';

interface BoldMarkdownProps {
  text: string;
}

export default function BoldMarkdown({ text }: BoldMarkdownProps): JSX.Element {
  const processBoldText = (str: string): JSX.Element[] => {
    // finds text between two double astersisk example: **text**
    const regex = /\*\*(.*?)\*\*/g;
    let lastIndex = 0;
    const result: JSX.Element[] = [];
    let match;

    while ((match = regex.exec(str)) !== null) {
      if (match.index > lastIndex) {
        result.push(<span key={`text-${lastIndex}`}>{str.slice(lastIndex, match.index)}</span>);
      }
      result.push(<strong key={`bold-${match.index}`}>{match[1]}</strong>);
      lastIndex = regex.lastIndex;
    }

    if (lastIndex < str.length) {
      result.push(<span key={`text-${lastIndex}`}>{str.slice(lastIndex)}</span>);
    }

    return result;
  };

  return <>{processBoldText(text)}</>;
}
